<template>
  <v-app>
    <div id="nav"></div>
    <VCConfigList></VCConfigList>
  </v-app>
</template>

<style lang="scss">

#nav {
  padding: 15px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>


<script>
  import VCConfigList from './views/VCConfigList'

  export default{

      name:'App',
      components:{
        VCConfigList
      }

  } 
</script>
